import { useEffect } from 'react'
import { useApolloClient } from 'react-apollo'

import { throttle } from 'lodash'

import {
  SESSION_INACTIVITY_DETECTED_SESSION_STORAGE_KEY,
  SESSION_REFRESH_QUEUED_SESSION_STORAGE_KEY,
  debouncedRefreshSessionCookies,
} from 'utils/session'

const SESSION_REFRESH_INTERVAL = 3 * 60 * 1000 // 3 minutes

export function SessionAutoRefresh() {
  const apolloClient = useApolloClient()

  useEffect(
    function sessionAutoRefresh() {
      if (apolloClient) {
        setTimeout(() => {
          window.document.addEventListener(
            'pointermove',
            throttle(
              () => {
                window.sessionStorage.setItem(
                  SESSION_REFRESH_QUEUED_SESSION_STORAGE_KEY,
                  'true',
                )
                debouncedRefreshSessionCookies(apolloClient)

                // If the "Are you still there?" is up, refresh the session immediately.
                if (
                  window.sessionStorage.getItem(
                    SESSION_INACTIVITY_DETECTED_SESSION_STORAGE_KEY,
                  ) === 'true'
                ) {
                  debouncedRefreshSessionCookies.flush()
                }
              },
              SESSION_REFRESH_INTERVAL,
              {
                trailing: false, // don't invoke the throttled function after the timeout
              },
            ),
          )
        }, SESSION_REFRESH_INTERVAL)
      }
    },
    [apolloClient],
  )

  return null
}
